module.exports = __webpack_public_path__ + "media/sound.0c481e87.mp3";